/* eslint-disable no-return-await */
import React, { useEffect, useState, useRef } from 'react';
import { Form } from '@unform/web';

import {
  Button,
  Card,
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CardBody,
  CardFooter,
} from 'reactstrap';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { Input } from '../../components/unform/index';
import api from '../../services/api';
import { useAuth } from '../../contexts/auth';
import { Translator } from '../../components/i18n';

function Usuario() {
  const obrigatorio = Translator({
    path: 'obrigatorio',
  });
  const dadosSalvosSucesso = Translator({
    path: 'dadosSalvosSucesso',
  });
  const erroSalvarDados = Translator({
    path: 'erroSalvarDados',
  });
  const { changeUser } = useAuth();
  const formRef = useRef();
  const formRefSenha = useRef();

  const [dadosUsuario, setDadosUsuario] = useState(null);
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  useEffect(() => {
    async function getDados() {
      const { data } = await api.get('/usuario');
      setDadosUsuario(data);
    }
    getDados();
  }, []);

  async function handleEdit(data) {
    const errors = {};

    Object.keys(data).forEach((f) => {
      if (!data[f]) {
        errors[f] = obrigatorio;
      }
    });

    formRef.current.setErrors(errors);

    if (!Object.keys(errors).length) {
      Swal.fire({
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      try {
        await api.put('/perfil', data);
        toast.success(dadosSalvosSucesso);
        changeUser({ nome: data?.nome });
        Swal.close();
      } catch (err) {
        toast.error(erroSalvarDados);
        Swal.close();
      }
    }
  }

  async function handleSenha(data) {
    const errors = {};

    Object.keys(data).forEach((f) => {
      if (!data[f]) {
        errors[f] = obrigatorio;
      }
    });

    formRefSenha.current.setErrors(errors);

    if (!Object.keys(errors).length) {
      Swal.fire({
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      try {
        await api.put('/senha', data);
        toast.success(dadosSalvosSucesso);
        toggle();
        Swal.close();
      } catch (err) {
        toast.error(erroSalvarDados);
        Swal.close();
      }
    }
  }

  return (
    <>
      <Row>
        <Col>
          <h4 className="mb-3">
            <Translator path="perfil.label" />
          </h4>
        </Col>
      </Row>
      <Card>
        <Form ref={formRef} onSubmit={(data) => handleEdit(data)}>
          <CardBody>
            <Row>
              <Col lg={6}>
                <Input
                  name="nome"
                  label={<Translator path="perfil.nome" />}
                  className="form-control"
                  defaultValue={dadosUsuario?.nome}
                  type="text"
                />
              </Col>
              <Col lg={6}>
                <Input
                  name="null"
                  label={<Translator path="perfil.email" />}
                  className="form-control"
                  type="text"
                  defaultValue={dadosUsuario?.email}
                  disabled
                />
                <code>
                  <Translator path="msg.perfil.email" />
                </code>
              </Col>
            </Row>
          </CardBody>
          <CardFooter>
            <Col>
              <Button color="secondary" onClick={() => toggle()} type="button">
                <Translator path="perfil.trocarsenha" />
              </Button>
            </Col>

            <Button color="success" type="submit">
              <Translator path="perfil.salvar" />
            </Button>
          </CardFooter>
        </Form>
      </Card>

      <Modal isOpen={modal} toggle={toggle} size="md">
        <ModalHeader toggle={toggle}>
          <Translator path="perfil.novasenhalabel" />
        </ModalHeader>
        <Form ref={formRefSenha} onSubmit={(data) => handleSenha(data)}>
          <ModalBody>
            <Row>
              <Col lg={6}>
                <Input
                  name="senha_antiga"
                  label={<Translator path="perfil.senhaanterior" />}
                  className="form-control"
                  type="password"
                />
              </Col>
              <Col lg={6}>
                <Input
                  name="nova_senha"
                  label={<Translator path="perfil.novasenha" />}
                  className="form-control"
                  type="password"
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="success" type="submit">
              <Translator path="perfil.salvar" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </>
  );
}

export default Usuario;
